
import { formatDateNormal, formatPriceRP, parsingErrorResponse, CLIENT_ERROR } from "@/app/infrastructures/misc/Utils";
import EmptyList from "@/app/ui/components/empty-list/index.vue";
import Icons from "@/app/ui/components/icons/index.vue";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { InstantBookingController } from "@/app/ui/controllers/InstantBookingController";
import { KulionerController } from "@/app/ui/controllers/KulionerController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { LocationController } from "@/app/ui/controllers/LocationController";
import { ShipmentBookingController } from "@/app/ui/controllers/ShipmentBookingController";
import { ShipmentInstantBooking } from "@/data/payload/api/ShipmentBookingRequest";
import { ShipmentId } from "@/domain/entities/Booking";
import { KulionerOrder } from "@/domain/entities/Kulioner";
import { ResponsePayload } from "@/domain/entities/ResponsePayload";
import { Options, Vue } from "vue-class-component";
import ModalSuccessProcessOrder from "../components/modal-success-process-order.vue";
import { ErrorMessageEntities } from '@/domain/entities/MainApp';
import generatePrintReceipt  from "../components/receipt"
import ModalProcessKulioner from "../components/ModalProcessKulioner.vue";

@Options({
  components: {
    EmptyList,
    ModalSuccessProcessOrder,
    ModalProcessKulioner
  }
})
export default class KulionerDetail extends Vue {
  successProcessResponse = new ResponsePayload();
  isShowSuccessProcessModal = false;
  formatPriceRP = formatPriceRP
  formatDateNormal = formatDateNormal
  isShowModalProcessKulioner = false;
  isShowModalAcceptOrder = false;
  isShowModalFailedOrder = false;

  detailData = new KulionerOrder()
  isLoading = false
  isError = false
  errorCause: any = ""
  isLoadingSubmitBtn = false;

  buttonActionError = {
    textColor: "white",
    title: "Muat ulang",
    iconLeft: "ics_o_reload"
  };
  sttId = 0;

  // Get Data
  created() {
    this.getDetail();
  }

  // route navigation
  goBack() {
    this.$router.push("/kulioner");
  }

  // close modal accept order
  closeModalSuccess() {
    this.$emit("successProcessOrder");
    this.getDetail();
  }

  // success modal accept order
  onSuccess() {
    this.closeModalOrderKulioner();
    this.isShowModalAcceptOrder = true;
  }

  // failed modal accept order
  onFailed() {
    this.closeModalOrderKulioner();
    this.isShowModalFailedOrder = true;
  }

  // close modal order
  closeModalOrderKulioner() {
    this.isShowModalProcessKulioner = false;
  }

  get id(): number {
    return Number(this.$route.params.id);
  }

  async getDetail() {
    this.isLoading = true
    this.isError = false
    this.errorCause = ""
    try {
      const resp = await KulionerController.getKulionerDetail(this.id);
      this.detailData = resp
    } catch (error) {
      this.isError = true
      this.errorCause = error
    } finally {
      this.isLoading = false
    }
  }

  async getDetailStt(sttNo: string) {
    try {
      MainAppController.showLoading();
      const resp = await KulionerController.getSttDetail({ sttNumber: sttNo });
      this.sttId = resp.data[0].sttId;
    } catch (error) {
      this.isError = true
      this.errorCause = parsingErrorResponse(error).type;
    } finally {
      MainAppController.closeLoading();
    }
  }

  censorPhoneLastFour = (num: number | string): string => {
    const str = typeof num === 'number' ? num.toString() : num;
    
    if (str.length <= 4) return '*'.repeat(str.length)
    
    const visiblePart = str.slice(0, -4);
    const censoredPart = '****';
    
    return visiblePart + censoredPart;
  };

  mapStatusLabel(item: string, customLabels?: { [key: string]: string }): string {
    const baseLabels = {
      ordwtc: "Pesanan baru",
      ordprc: "Pesanan diproses",
      ordbkd: "Pesanan perlu dikirim",
      orddlv: "Pesanan dikirim",
      cncwrf: "Pesanan dibatalkan",
      ordrcv: "Pesanan selesai"
    };

    const mergedLabels = { ...baseLabels, ...customLabels };
    const status = item.toLowerCase() as keyof typeof mergedLabels;
    return mergedLabels[status] || item;
  }

  mapUpdateStatusLabel(item: string): string {
    return this.mapStatusLabel(item);
  }

  mapDeliveryStatusLabel(item: string): string {
    return this.mapStatusLabel(item, { ordrcv: "Selesai" });
  }

  get filteredHistorries() {
    return this.detailData.koHistories.sort((a, b) =>
      new Date(b.kohCreatedAt).getTime() -
      new Date(a.kohCreatedAt).getTime()
    )
  }

  get deliveryStatusStyling() {
    const status = this.detailData.koStatus.toLowerCase()
    const backgorund: any = () => {
      const obj = {
        ordwtc: "bg-yellow-lp-400 border-yellow-lp-100",
        ordprc: "bg-blue-lp-600 border-blue-lp-500",
        ordbkd: "bg-aqua-lp-200 border-aqua-lp-300",
        orddlv: "bg-purple-lp-100 border-purple-lp-900",
        ordrcv: "bg-green-lp-500 border-green-lp-200",
        cncwrf: "bg-red-lp-1100 border-red-lp-100"
      } as any
      return obj[status] ?? "bg-yellow-lp-400 border-yellow-lp-100"
    }
    const label: any = () => {
      const obj = {
        ordwtc: "text-yellow-lp-500",
        ordprc: "text-blue-lp-700",
        ordbkd: "text-aqua-lp-900",
        orddlv: "text-purple-lp-700",
        ordrcv: "text-green-lp-400",
        cncwrf: "text-red-lp-1600"
      } as any
      return obj[status] ?? "text-yellow-lp-500"
    }
    const value: any = () => {
      const obj = {
        ordwtc: "text-yellow-lp-100",
        ordprc: "text-blue-lp-500",
        ordbkd: "text-aqua-lp-300",
        orddlv: "text-purple-lp-900",
        ordrcv: "text-green-lp-200",
        cncwrf: "text-red-lp-100"
      } as any
      return obj[status] ?? "text-yellow-lp-100"
    }
    return { 
      background: backgorund(),
      label: label(),
      value: value()
    }
  }

  get buttonTitle() {
    return this.detailData.koStatus.toLowerCase() === "ordwtc" ? "Terima pesanan" : this.detailData.koStatus.toLowerCase() === "ordprc" ? "Proses pengiriman" : ""
  }

  get buttonId() {
    return this.detailData.koStatus.toLowerCase() === "ordwtc" ? "button_accept_order_detail_kulioner" : "button_process_order_detail_kulioner"
  }

  get deliveryStatusBackgroundColor() {
    const status = this.detailData.koStatus.toLowerCase()
    const top: any = () => {
      const obj = {
        ordwtc: "#FAB713",
        ordprc: "#2468F6",
        ordbkd: "#51B6D5",
        orddlv: "#6257BA",
        ordrcv: "#7ACB90",
        cncwrf: "#E13E49"
      } as any
      return obj[status] ?? "text-yellow-lp-500"
    }
    const bottom: any = () => {
      const obj = {
        ordwtc: "#FAB713",
        ordprc: "#2468F6",
        ordbkd: "#51B6D5",
        orddlv: "#6257BA",
        ordrcv: "#00875A",
        cncwrf: "#B82025"
      } as any
      return obj[status] ?? "text-yellow-lp-100"
    }
    return { 
      top: top(),
      bottom: bottom()
    }
  }

  isLoadingPrintReceipt = false;
  async onPrintReceipt(sttNo: string, language = "id") {
    try {
      this.isLoadingPrintReceipt = true;
      const book: any = await import(
        "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
      );
      await this.getDetailStt(sttNo);

      book.default.methods.printBasic(this.sttId, 0, language, false, false);
    } finally {
      this.isLoadingPrintReceipt = false;
    }
  }

  get errorData() {
    const error = this.errorCause?.response ? "server" : "internet"
    const icon = error === "server" ? "error-token-ngen" : "error-internet"
    const header = error === "server" ? "Terjadi gangguan sistem" : "Jaringan internet terputus"
    const message = error === "server" ? `Klik "Muat ulang" atau coba beberapa saat lagi.` : `Periksa jaringan internal Anda lalu klik "Muat ulang".`
    return { icon: icon, header: header, message: message }
  }

  async onProcessOrder() {
    if (this.isLoadingSubmitBtn) return;
    if (this.detailData.koOrderShipmentId.startsWith("AD")) {
      try {
        MainAppController.showLoading();
        this.isLoadingSubmitBtn = true;
        const res = await KulionerController.getShipmentIdList(this.detailData.koOrderShipmentId);
        this.addShipmentToBook(res.data);
      } catch (err) {
        MainAppController.closeLoading();
        this._showErrorProccessOrder(err);
        this.isLoadingSubmitBtn = false;
      }
    }
  }

  addShipmentToBook(data: any, type = "non-kr") {
    if (data.length > 0) {
      for (const row of data) {
        this.onProcessBook(row);
      }
      return;
    }
  }

  async onProcessBook(detail: ShipmentId) {
    this.addInstantBooking(detail);
  }
  
  get originDistrict() {
    const detail = LocationController.districtDetail;
    return {
      id: detail.id,
      name: `${detail.name}, ${detail.cityName}`,
      code: `${detail.code}`,
      cityCode: `${detail.cityCode}`,
      ursaCode: detail.ursaCode,
      cityId: detail.cityId,
      cityName: detail.cityName
    };
  }

  get dataProfile() {
    return AccountController.accountData;
  }

  mappingSttPieces(shipment: any) {
    return shipment.shipmentGoodDetail.length
      ? shipment.shipmentGoodDetail.map((pieces: any) => ({
          "stt_piece_length": pieces.shipment_goods_length,
          "stt_piece_width": pieces.shipment_goods_width,
          "stt_piece_height": pieces.shipment_goods_height,
          "stt_piece_gross_weight": pieces.shipment_goods_weight
        }))
      : [];
  }

  payloadSttOne(shipment: ShipmentId) {
    return {
      sttNo: "",
      sttShipmentId: shipment.shipmentAlgoId,
      sttTaxNumber: "",
      sttGoodsEstimatePrice: shipment.shipmentGoodsPriceEstimation,
      sttGoodsStatus: shipment.shipmentGoodsStatus,
      sttNoRefExternal: shipment.shipmentBookingId.startsWith("TSLP") ? shipment.shipmentBookingId : "",
      sttOriginCityId: this.originDistrict.cityCode,
      sttDestinationCityId: shipment.shipmentDestinationCity?.code,
      sttOriginDistrictId: this.originDistrict.code
    }
  }

  payloadSttTwo(shipment: ShipmentId) {
    return {
      sttDestinationDistrictId: shipment.shipmentDestinationDistrict?.code,
      sttSenderName: shipment.shipmentSenderName,
      sttSenderPhone: shipment.senderPhoneInstantBooking,
      sttSenderAddress: shipment.shipmentSenderAddress,
      sttRecipientName: shipment.shipmentRecipientName,
      sttRecipientPhone: shipment.recipientPhoneInstantBooking,
      sttRecipientAddress: shipment.shipmentRecipientAddress,
      sttProductType: shipment.shipmentProduct,
      sttCommodityCode: shipment.shipmentCommodityCode || "GEN",
      sttInsuranceType: shipment.shipmentInsurance
    }
  }

  payloadSttThree(shipment: ShipmentId) {
    return {
      sttIsDo: shipment.isDO,
      sttIsCod: shipment.shipmentIsCod,
      sttIsDfod: shipment.shipmentIsDfod,
      sttCodFee: shipment.codFee,
      sttCodAmount: shipment.codAmount,
      sttPieces: this.mappingSttPieces(shipment),
      postalCodeDestination: shipment.postalCodeDestination,
      addressReceiverType: "home",
      sttWoodpacking: shipment.shipmentIsWoodpacking
    }
  }

  mappingPayloadStt(shipment: any) {
    return {
      ...this.payloadSttOne(shipment),
      ...this.payloadSttTwo(shipment),
      ...this.payloadSttThree(shipment)
    }
  }

  async addInstantBooking(shipment: ShipmentId) {
    const accountTypeDetail = this.dataProfile.account_type_detail || {}
    await ShipmentBookingController.addInstantBooking(
      new ShipmentInstantBooking({
        shipmentPackageId: shipment.shipmentPacketId,
        stt: this.mappingPayloadStt(shipment),
        districtOrigin: {
          id: this.originDistrict.id,
          code: this.originDistrict.code,
          name: this.originDistrict.name,
          ursaCode: this.originDistrict.ursaCode,
          city: {
            id: this.originDistrict.cityId,
            code: this.originDistrict.cityCode,
            name: this.originDistrict.cityName
          }
        },
        districtDestination: {
          id: shipment.shipmentDestinationDistrict.id,
          code: shipment.shipmentDestinationDistrict.code,
          name: shipment.shipmentDestinationDistrict.name,
          ursaCode: shipment.shipmentDestinationDistrict.ursa_code,
          city: {
            id: shipment.shipmentDestinationCity.id,
            code: shipment.shipmentDestinationCity.code,
            name: shipment.shipmentDestinationCity.name
          }
        },
        commodity: {
          commodityId: shipment.shipmentCommodityId,
          commodityCode: shipment.shipmentCommodityCode,
          commodityName: shipment.shipmentCommodityName,
          commodityDocumentSurcharge:
            shipment.shipmentCommodityDocumentSurcharge,
          hsCode: shipment.shipmentCommodityHsCode
        },
        partner: {
          id: accountTypeDetail.id,
          name: accountTypeDetail.company_name,
          code: accountTypeDetail.code,
          partnerExternalCode: this.dataProfile.account_type_detail
            ?.partnerExternalCode,
          partnerLocation: {
            id: accountTypeDetail.partnerLocation?.id,
            districtCode: accountTypeDetail.partnerLocation
              ?.district_code
          },
          partnerLocationList: []
        }
      })
    )
    .then((res: ResponsePayload) => {
      // open modal success
      this.successProcessResponse = res;
      this.isShowSuccessProcessModal = true;
    })
    .catch((error: any) => {
      // open modal error
      this._showErrorProccessOrder(error);
    }).finally(() => {
      this.isLoadingSubmitBtn = false;
      MainAppController.closeLoading();
    });
  }

  _showErrorProccessOrder(error: any) {
    MainAppController.showErrorMessage(new ErrorMessageEntities({
      title: "Booking gagal",
      message: error.response.data?.message?.id || "",
      type: CLIENT_ERROR,
      buttonSuccessText: "Oke, mengerti",
      onClose: () => {
        MainAppController.closeErrorMessage();
      }
    }))
  }

  onButtonClick() {
    if (this.detailData.koStatus.toLowerCase() === "ordprc") {
      this.onProcessOrder();
    } else if (this.detailData.koStatus.toLowerCase() === "ordwtc") {
      this.isShowModalProcessKulioner = true;
    }
  }

  isLoadingDownloadOrder = false;
  async onDownloadOrder() {
    this.isLoadingDownloadOrder = true;
    // action download order
    await generatePrintReceipt([this.detailData]);
    this.isLoadingDownloadOrder = false;
  }
}
